import {
    OPEN_SIGNIN_DRAWER,
    CLOSE_SIGNIN_DRAWER,
    OPEN_SIGNUP_DRAWER,
    CLOSE_SIGNUP_DRAWER,
    OPEN_FORGOT_PASSWORD_DRAWER,
    CLOSE_FORGOT_PASSWORD_DRAWER,
    OPEN_DASHBOARD_DRAWER,
    CLOSE_DASHBOARD_DRAWER,
    OPEN_NAVIGATION_DRAWER,
    CLOSE_NAVIGATION_DRAWER,
} from './types';

/**
 * Shows or hide (toggle) a given drawer.
 *
 * @param {string} drawer   Name of the drawer
 * @param {boolean} open    Open or close
 */
export const toggleDrawer = (drawer, open) => dispatch => {
    switch (drawer) {
        case 'signin':
            if (open) {
                dispatch(openSigninDrawer());
            } else {
                dispatch(closeSigninDrawer());
            }
            break;
        case 'signup':
            if (open) {
                dispatch(openSignupDrawer());
            } else {
                dispatch(closeSignupDrawer());
            }
            break;
        case 'forgotPassword':
            if (open) {
                dispatch(openForgotPasswordDrawer());
            } else {
                dispatch(closeForgotPasswordDrawer());
            }
            break;
        case 'dashboard':
            if (open) {
                dispatch(openDashboardDrawer());
            } else {
                dispatch(closeDashboardDrawer());
            }
            break;
        case 'navigation':
            if (open) {
                dispatch(openNavigationDrawer());
            } else {
                dispatch(closeNavigationDrawer());
            }
            break;
        default:
            break;
    }
};

/**
 * Closes a current opened drawer, and open a new one.
 *
 * @param {string} drawerToClose    Name of the drawer to close
 * @param {string} drawerToopen     Name of the drawer to open
 */
export const switchDrawer = (drawerToClose, drawerToopen) => dispatch => {
    dispatch(toggleDrawer(drawerToClose, false));
    dispatch(toggleDrawer(drawerToopen, true));
};

export const openSigninDrawer = () => {
    return {
        type: OPEN_SIGNIN_DRAWER
    };
};

export const closeSigninDrawer = () => {
    return {
        type: CLOSE_SIGNIN_DRAWER
    };
};

export const openSignupDrawer = () => {
    return {
        type: OPEN_SIGNUP_DRAWER
    };
};

export const closeSignupDrawer = () => {
    return {
        type: CLOSE_SIGNUP_DRAWER
    };
};

export const openForgotPasswordDrawer = () => {
    return {
        type: OPEN_FORGOT_PASSWORD_DRAWER
    };
};

export const closeForgotPasswordDrawer = () => {
    return {
        type: CLOSE_FORGOT_PASSWORD_DRAWER
    };
};

export const openDashboardDrawer = () => {
    return {
        type: OPEN_DASHBOARD_DRAWER
    };
};

export const closeDashboardDrawer = () => {
    return {
        type: CLOSE_DASHBOARD_DRAWER
    };
};

export const openNavigationDrawer = () => {
    return {
        type: OPEN_NAVIGATION_DRAWER
    };
};

export const closeNavigationDrawer = () => {
    return {
        type: CLOSE_NAVIGATION_DRAWER
    };
};



// WEBPACK FOOTER //
// ./src/features/Layout/actions.js